import React from 'react';
import { makeStyles } from '@mui/styles';
import { TableRow, TableCell } from '@mui/material';
import NutrientRangeSlider from '../../NutrientRangeSlider/NutrientRangeSlider';
import NutrientItemTitle from './NutrientItemTitle';
import { NUTRIENT_TABLE_CONSTANTS } from '../utils/nutrientTableConstants';
const { DESKTOP_COLUMN_WIDTHS } = NUTRIENT_TABLE_CONSTANTS;

const useStyles = makeStyles((theme) => ({
  tableRow: {
    height: '60px',
    paddingTop: '16px',
    display: 'flex',
    width: 'auto',
    '& td': {
      borderBottom: 'none',
    },
  },
  tableBody: {
    paddingTop: '16px',
  },
  tableHead: {
    marginBottom: '16px',
  },
  unitRegular: theme.globalClasses.unitRegular,
  unitBold: theme.globalClasses.unitBold,
  cellContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  cellContentCentered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  slidersContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '7px',
    alignItems: 'center',
    width: '100%',
  },
  nutrientCell: {
    ...DESKTOP_COLUMN_WIDTHS.nutrient,
  },
  currentCell: {
    ...DESKTOP_COLUMN_WIDTHS.current,
  },
  goalCell: {
    ...DESKTOP_COLUMN_WIDTHS.goal,
  },
  changeCell: {
    ...DESKTOP_COLUMN_WIDTHS.change,
  },
  sliderCell: {
    ...DESKTOP_COLUMN_WIDTHS.slider,
  },
}));

const getCell = ({ data, unit = '', type = '' }) => {
  const classes = useStyles();

  // If data is 0 or empty, don't show anything
  if (!data && data !== 0) {
    return <TableCell className={classes[`${type}Cell`]} />;
  }

  return (
    <TableCell className={classes[`${type}Cell`]}>
      <div className={classes.cellContentCentered}>
        {data === 0 ? null : (
          <span className={classes.unitBold}>
            {data}
            {unit && <span className={classes.unitRegular}>&nbsp;{unit}</span>}
          </span>
        )}
      </div>
    </TableCell>
  );
};

const NutrientRow = ({ item, calculatedChange, longDescription, type }) => {
  const classes = useStyles();
  const excludeSlider = type?.trim().toLowerCase() === 'fats' || item.key?.trim().toLowerCase() === 'total-sugars';
  const hasGoal = 'goal' in item;

  // Convert string values to numbers
  const currentValue = Number(item.current) || 0;
  const goalValue = Number(item.goal) || 0;

  return (
    <TableRow className={classes.tableRow}>
      {hasGoal ? (
        <>
          <TableCell className={classes.nutrientCell}>
            <NutrientItemTitle
              name={item.name}
              longDescription={longDescription}
            />
          </TableCell>
          {getCell({ data: currentValue, unit: item.unit, type: 'current' })}
          {getCell({ data: goalValue, unit: item.unit, type: 'goal' })}
          {getCell({ data: calculatedChange, type: 'change' })}
          <TableCell className={classes.sliderCell}>
            <div className={classes.slidersContainer}>
              {!excludeSlider && (
                <NutrientRangeSlider
                  currentValue={currentValue}
                  goalValue={goalValue}
                  name={item.key}
                  unit={item.unit}
                  dv={item.dv}
                  dailyCalories={item.dailyCalories}
                />
              )}
            </div>
          </TableCell>
        </>
      ) : (
        <>
          <TableCell
            className={classes.nutrientCell}
            style={{ width: '50%' }}
          >
            <NutrientItemTitle
              name={item.name}
              longDescription={longDescription}
            />
          </TableCell>
          <TableCell
            className={classes.currentCell}
            style={{ width: '50%', textAlign: 'right' }}
          >
            <div className={classes.cellContentCentered}>
              <span className={classes.unitBold}>
                {currentValue}
                {item.unit && <span className={classes.unitRegular}>&nbsp;{item.unit}</span>}
              </span>
            </div>
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

export default NutrientRow;
